import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

export class SchemaSetModel extends ValuableModel {
  @fromNode()
  @reactive('deep')
  entries?: any[]
}

declare global {
  export interface RehajeViewModels {
    'Schema.Set': SchemaSetModel
  }
}
